import { createReducer, on } from '@ngrx/store';
import {
  initialDeviceApplicationStateStoreState,
  DeviceApplicationStateStoreState,
} from './device-application-state.state';
import {
  DeviceApplicationStateResolverActions,
  DeviceApplicationStateApiActions,
} from './device-application-state.actions';
import { DeviceState } from '@era/appmanagement-sdk';

export const deviceApplicationStateReducer = createReducer<DeviceApplicationStateStoreState>(
  initialDeviceApplicationStateStoreState,
  on(DeviceApplicationStateResolverActions.deviceApplicationStatesRequested, (state) => ({
    ...state,
    error: undefined,
  })),
  on(DeviceApplicationStateApiActions.deviceApplicationStatesLoaded, (state, { states }) => ({
    ...state,
    loaded: true,
    entities: states.reduce<Record<string, DeviceState>>((acc, cur) => {
      if (cur.udid) acc[cur.udid] = cur;
      return acc;
    }, {}),
  })),
  on(DeviceApplicationStateApiActions.deviceApplicationStatesLoadFailed, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);
